import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// Material
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

// Assets
import verifiableEvidence from "../../assets/backgrounds/getConnectedPage/verifiableEvidence.png";
import implementationBg from "../../assets/backgrounds/getConnectedPage/implementationBg.png";
import elipse from "../../assets/backgrounds/elipse.svg";

// Components
import Section from "../../components/Section/Section";
import Text, { types } from "../../components/Text/Text";

// Icons
import insurance from "../../assets/backgrounds/getConnectedPage/insurance.png";
import industry from "../../assets/backgrounds/getConnectedPage/industry.png";
import auth from "../../assets/backgrounds/getConnectedPage/auth.png";
import healtcare from "../../assets/backgrounds/getConnectedPage/healtcare.png";
import LinkScroll from "../../components/LinkScroll/LinkScroll";
import urls from "../../config/urls";

const useStyles = makeStyles(theme => ({
  root: {
    padding: "240px 8%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(4),
    backgroundImage: `url(${implementationBg})`,
    backgroundPosition: "bottom right",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    [theme.breakpoints.down("md")]: {
      paddingTop: "180px"
    },
    [theme.breakpoints.down("sm")]: {
      gap: 0,
      padding: "48px 0 100px"
    },
    [`&:after`]: {
      [theme.breakpoints.up(1440)]: {
        content: '""',
        position: "absolute",
        top: "20%",
        right: "unset",
        left: "0",
        height: 300,
        width: 150,
        filter: "saturate(0) brightness(2)",
        backgroundImage: `url(${elipse})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        transform: "translateY(25%)",
        zIndex: "1"
      },
      [theme.breakpoints.down("md")]: {
        height: 250,
        width: 125
      },
      [theme.breakpoints.down(1440)]: {
        height: 200,
        width: 100,
        left: "0",
        right: "unset"
      }
    }
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    position: "relative",
    justifyContent: "flex-end",
    width: "100%",
    marginBottom: "275px",
    [theme.breakpoints.down(1440)]: {
      flexDirection: "column",
      alignItems: "center"
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "15px"
    }
  },
  title: {
    color: "#171817",
    margin: "0",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      width: "100%",
      maxWidth: "18ch",
      marginBottom: theme.spacing(1)
    }
  },
  heading: {
    textAlign: "center",
    margin: "0",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "34ch"
    }
  },
  imgWrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down(1440)]: {
      height: "400px"
    },
    [theme.breakpoints.down("sm")]: {
      overflow: "hidden",
      height: "100%",
      width: "100%"
    }
  },
  image: {
    width: "800px",
    position: "absolute",
    left: "50%",
    transform: " translateX(-100%)",
    zIndex: "10",
    [theme.breakpoints.down("md")]: {
      width: "40vw",
      left: "unset",
      right: "800px",
      transform: "none"
    },
    [theme.breakpoints.down(1440)]: {
      width: "600px",
      display: "block",
      transform: "none",
      right: "unset"
    },
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      display: "block",
      width: "auto",
      height: "778px"
    }
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingTop: "120px",
    zIndex: "10",
    [theme.breakpoints.down(1440)]: {
      width: "100%",
      paddingTop: "0"
    },
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
      padding: "0 12px"
    }
  },
  cardRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
    [theme.breakpoints.down(1440)]: {
      width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1)
    },
    [theme.breakpoints.down(415)]: {
      flexDirection: "column"
    }
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: 445,
    backgroundColor: "#fff",
    borderRadius: "40px",
    border: "1px solid #E0E0E0",
    boxShadow: "0px 0px 30px #0000000D",
    padding: theme.spacing(6, 4),
    [theme.breakpoints.down(1440)]: {
      flex: 1
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      padding: theme.spacing(6, 2),
      flex: 1,
      borderRadius: "12px"
    },
    [theme.breakpoints.down(415)]: {
      width: "100%"
    }
  },
  menuItemIcon: {
    height: "100px",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      height: "66px"
    }
  },
  subtitleCard: {
    fontSize: "30px",
    width: "20ch",
    fontFamily: ["Montserrat", "sans-serif"].join(","),
    lineHeight: 1.2,
    fontWeight: 500,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      fontSize: "24px"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
      textAlign: "center",
      fontWeight: 600,
      width: "auto"
    }
  },
  descriptionCard: {
    fontSize: "20px",
    fontFamily: ["Montserrat", "sans-serif"].join(","),
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: "18px"
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: "16px"
    }
  },
  button: {
    fontFamily: "Montserrat Black",
    textTransform: "none",
    fontSize: "24px",
    padding: "28px 175px",
    borderRadius: "10px",
    boxShadow: "0px 3px 66px #00000029",
    color: "#fff",
    lineHeight: 1,
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      padding: "24px 90px",
      width: "calc(100% - 24px)",
      height: "70px"
    }
  }
}));

const GetConnectedVerifiableEvidence = () => {
  const classes = useStyles();

  return (
    <Section className={classes.root}>
      <Text type={types.sectionTitle} className={classes.title}>
        Authenticated, Verifiable Evidence
      </Text>
      <Text type={types.titleDescription} className={classes.heading}>
        No matter what sector you’re in, you can benefit from a connection
      </Text>
      <div className={classes.wrapper}>
        <div className={classes.imgWrapper}>
          <img
            src={verifiableEvidence}
            className={classes.image}
            alt="Implementation"
          />
        </div>
        <div className={classes.cardContainer}>
          <div className={classes.cardRow}>
            <Paper className={classes.card}>
              <img
                src={insurance}
                alt="Staffordshire Police"
                className={classes.menuItemIcon}
              />
              <Typography className={classes.subtitleCard}>
                Insurance
              </Typography>
              <Typography className={classes.descriptionCard}>
                Improve claims evidence, reduce split liability agreements and
                detect fraudulent claims or Ai-generated imagery.
              </Typography>
            </Paper>
            <Paper className={classes.card}>
              <img
                src={industry}
                alt="Staffordshire Police"
                className={classes.menuItemIcon}
              />
              <Typography className={classes.subtitleCard}>
                Heavy industry
              </Typography>
              <Typography className={classes.descriptionCard}>
                To assist with accident reporting and incident claims.
              </Typography>
            </Paper>
          </div>
          <div className={classes.cardRow}>
            <Paper className={classes.card}>
              <img
                src={healtcare}
                alt="Staffordshire Police"
                className={classes.menuItemIcon}
              />
              <Typography className={classes.subtitleCard}>
                Healthcare and Universities
              </Typography>
              <Typography className={classes.descriptionCard}>
                Supporting reporting duties and safeguarding actions.
              </Typography>
            </Paper>
            <Paper className={classes.card}>
              <img
                src={auth}
                alt="Staffordshire Police"
                className={classes.menuItemIcon}
              />
              <Typography className={classes.subtitleCard}>
                Local authorities
              </Typography>
              <Typography className={classes.descriptionCard}>
                For housing enforcement, anti-social behaviour, environmental
                complaints and infrastructure issues.
              </Typography>
            </Paper>
          </div>
        </div>
      </div>
      <Button
        className={classes.button}
        color="secondary"
        variant="contained"
        disableElevation
        component={LinkScroll}
        to={`${urls.getConnected}#demo`}
      >
        Book a demo
      </Button>
    </Section>
  );
};

export default GetConnectedVerifiableEvidence;
